module.exports = __webpack_public_path__ + "static/media/project.e474870b.png";